import CartService from './Cart';
import Pricing from "./Pricing";
import Promos from "./Promos";
import NewsletterSignup from "./NewsletterSignup";
import Locations from "./Locations";
import Search from "./Search";
import Order from "./Order";
import PersonalShopper from "./PersonalShopper";
import ActOnEmailCapture from "./ActOnEmailCapture";
import StoreLookupService from "./StoreLookup";
import FBPixel from "./FBPixel";

const services = {
    cart: CartService,
    locations: Locations,
    newsletterSignup: NewsletterSignup,
    order: Order,
    personalShopper: PersonalShopper,
    pricing: Pricing,
    promos: Promos,
    search: Search,
    actOnEmailCapture: ActOnEmailCapture,
    storeLookup: StoreLookupService,
    fbPixel: FBPixel,
};

export const ServiceFactory = {
    get: name => services[name]
}
